import styled from 'styled-components';
import { flexCenter } from '@anm/styles/helpers';

const Wrapper = styled.div`
  ${flexCenter};
`;

export const SecureCardDescription = styled.span`
  margin-left: 13px;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
`;

export default Wrapper;
